"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const meAppSpaces = (accessToken) => __awaiter(void 0, void 0, void 0, function* () {
    const headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', `Bearer ${accessToken}`);
    const response = yield (yield fetch('https://api.sportnet.online/v1/me/appspaces?expandApp=true', {
        headers,
    })).json();
    const { apps } = response;
    return (apps || []).map((a) => {
        var _a, _b, _c;
        return Object.assign({ app: {
                _id: a.app_id,
                name: (_a = a.app) === null || _a === void 0 ? void 0 : _a.name,
                logo: (_b = a.app) === null || _b === void 0 ? void 0 : _b.logo,
                url: (_c = a.app) === null || _c === void 0 ? void 0 : _c.url,
            } }, (!!a.appspaces && {
            appSpaces: a.appspaces.map((a) => {
                var _a, _b, _c;
                return ({
                    logo: (_a = a.org_profile) === null || _a === void 0 ? void 0 : _a.logo_public_url,
                    ppo: a.app_space,
                    organizationName: (_b = a.org_profile) === null || _b === void 0 ? void 0 : _b.organization_name,
                    organizationProfileName: (_c = a.org_profile) === null || _c === void 0 ? void 0 : _c.name,
                    displayName: a.display_name,
                    role: a.role,
                    validTo: a.validTo,
                });
            }),
        }));
    });
});
exports.default = meAppSpaces;
